@if (visibleLayers.size) {
  <div
    ng-container
    class="container"
    data-testid="jmkw-legends"
    >
    @if (showButtons$ | async) {
      <button
        automationKey="legend-left-button"
        #leftButton
        (click)="scroll('left')"
        >
        &#8249;
      </button>
    }
    <div class="legends" #legendsContainer cdkScrollable>
      <!-- legendPlugin.key is the plugin id -->
      @for (legend of legendMap() | keyvalue: sort; track legend) {
        @if (visibleLayers.has(legend.key)) {
          <jmkw-legend-wrapper
            [id]="legend.key"
            [legendParams]="legend.value"
            >
          </jmkw-legend-wrapper>
        }
      }
    </div>
    @if (showButtons$ | async) {
      <button
        automationKey="legend-right-button"
        #rightButton
        (click)="scroll('right')"
        >
        &#8250;
      </button>
    }
  </div>
}
